import { montarEndereco } from '../../components/applications/enderecoDoAssistente';

/**
 * O endereço dos botões "Aplicar" da lista de Cargos (#606, D14): o nível de cargo e a empresa e
 * o setor que estão filtrados. Sem o cargo o destino fica incompleto, e a tela de aplicação abre
 * na etapa 1 com o que veio já escolhido. `voltar` é a lista, para onde "Concluir" leva de volta.
 */
export function enderecoDeAplicar(
  caminho: string,
  filtros: { companyId?: number; departmentId?: number },
  voltar?: string
): string {
  return montarEndereco(caminho, {
    nivel: 'occupation',
    ids: { company: filtros.companyId || null, department: filtros.departmentId || null },
    voltar,
  });
}
